/* Néovira — thème v2 : annonces, en-tête, panier latéral, page produit, accordéons, FAQ, stories, pop-up */
(function () {
  'use strict';
  var d = document;
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function qsa(root, sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }
  function root() { return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'; }

  /* ---------- annonces ---------- */
  function initAnn(el) {
    var msgs = qsa(el, '.nv-ann__msg');
    if (msgs.length < 2) return;
    var i = 0, timer = null, speed = parseInt(el.getAttribute('data-speed'), 10) || 5000;
    function show(n) {
      i = (n + msgs.length) % msgs.length;
      msgs.forEach(function (m, k) { m.classList.toggle('is-active', k === i); m.setAttribute('aria-hidden', k === i ? 'false' : 'true'); });
    }
    function start() { if (reduceMotion) return; stop(); timer = setInterval(function () { show(i + 1); }, speed); }
    function stop() { if (timer) clearInterval(timer); timer = null; }
    var prev = el.querySelector('[data-nv-ann-prev]'), next = el.querySelector('[data-nv-ann-next]');
    if (prev) prev.addEventListener('click', function () { show(i - 1); start(); });
    if (next) next.addEventListener('click', function () { show(i + 1); start(); });
    el.addEventListener('mouseenter', stop);
    el.addEventListener('mouseleave', start);
    el.addEventListener('focusin', stop);
    show(0); start();
  }

  /* ---------- en-tête + menu mobile ---------- */
  function initHeader() {
    var hd = d.querySelector('[data-nv-header]');
    if (hd) {
      var onScroll = function () { hd.classList.toggle('is-scrolled', window.scrollY > 8); };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }
    var menu = d.querySelector('[data-nv-menu]');
    var opener = d.querySelector('[data-nv-menu-open]');
    if (!menu || !opener) return;
    function open() {
      menu.classList.add('is-open'); menu.setAttribute('aria-hidden', 'false'); opener.setAttribute('aria-expanded', 'true');
      d.body.classList.add('nv-drawer-open');
      var first = menu.querySelector('a, button'); if (first) setTimeout(function () { first.focus(); }, 50);
    }
    function close() {
      menu.classList.remove('is-open'); menu.setAttribute('aria-hidden', 'true'); opener.setAttribute('aria-expanded', 'false');
      d.body.classList.remove('nv-drawer-open'); opener.focus();
    }
    opener.addEventListener('click', open);
    qsa(menu, '[data-nv-menu-close]').forEach(function (b) { b.addEventListener('click', close); });
    qsa(menu, '[data-nv-menu-link]').forEach(function (a) { a.addEventListener('click', function () { if (a.getAttribute('href').indexOf('#') > -1) close(); }); });
    d.addEventListener('keydown', function (e) { if (e.key === 'Escape' && menu.classList.contains('is-open')) close(); });
  }

  /* ---------- panier latéral ---------- */
  var drawer = null, lastFocus = null;
  function drawerOpen() {
    if (!drawer) return false;
    lastFocus = d.activeElement;
    drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden', 'false'); d.body.classList.add('nv-drawer-open');
    var panel = drawer.querySelector('.nv-drawer__panel'); if (panel) setTimeout(function () { panel.focus(); }, 60);
    return true;
  }
  function drawerClose() {
    if (!drawer) return;
    drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden', 'true'); d.body.classList.remove('nv-drawer-open');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  function renderDrawer(html, count) {
    if (!drawer || !html) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.querySelector('.nv-drawer__panel');
    var panel = drawer.querySelector('.nv-drawer__panel');
    if (fresh && panel) panel.innerHTML = fresh.innerHTML;
    if (typeof count === 'number') setCount(count);
  }
  function setCount(n) {
    qsa(d, '[data-nv-cart-count]').forEach(function (el) { el.textContent = n; el.hidden = n === 0; });
    qsa(d, '[data-nv-cart-open]').forEach(function (a) { a.setAttribute('aria-label', 'Panier (' + n + ')'); });
  }
  function cartRequest(url, body, isForm) {
    var opts = { method: 'POST', headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' } };
    if (isForm) { opts.body = body; } else { opts.headers['Content-Type'] = 'application/json'; opts.body = JSON.stringify(body); }
    return fetch(url, opts).then(function (r) { return r.json().then(function (j) { if (!r.ok) { var err = new Error(j.description || j.message || 'Erreur'); throw err; } return j; }); });
  }
  function refreshCount() {
    return fetch(root() + 'cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) { setCount(c.item_count); return c; });
  }
  function initDrawer() {
    drawer = d.querySelector('[data-nv-drawer]');
    qsa(d, '[data-nv-cart-open]').forEach(function (a) {
      a.addEventListener('click', function (e) { if (drawer) { e.preventDefault(); drawerOpen(); } });
    });
    if (!drawer) return;
    drawer.addEventListener('click', function (e) {
      if (e.target.closest('[data-nv-drawer-close]')) { drawerClose(); return; }
      var btn = e.target.closest('[data-nv-qty-change]');
      if (btn) {
        var line = btn.closest('[data-nv-line]');
        changeLine(parseInt(line.getAttribute('data-nv-line'), 10), parseInt(btn.getAttribute('data-nv-qty-change'), 10));
      }
    });
    drawer.addEventListener('change', function (e) {
      if (e.target.matches('[data-nv-qty-input]')) {
        var line = e.target.closest('[data-nv-line]');
        changeLine(parseInt(line.getAttribute('data-nv-line'), 10), Math.max(0, parseInt(e.target.value, 10) || 0));
      }
    });
    d.addEventListener('keydown', function (e) { if (e.key === 'Escape' && drawer.classList.contains('is-open')) drawerClose(); });
  }
  function changeLine(line, qty) {
    drawer.classList.add('is-busy');
    cartRequest(root() + 'cart/change.js', { line: line, quantity: Math.max(0, qty), sections: ['nv-cart-drawer'], sections_url: window.location.pathname })
      .then(function (c) { renderDrawer(c.sections && c.sections['nv-cart-drawer'], c.item_count); })
      .catch(function () { window.location.href = root() + 'cart'; })
      .then(function () { drawer.classList.remove('is-busy'); });
  }
  function initAddForms() {
    d.addEventListener('submit', function (e) {
      var form = e.target;
      if (!drawer || !form.matches('form[action*="/cart/add"]')) return;
      e.preventDefault();
      var btns = qsa(d, '[form="' + form.id + '"]').concat(qsa(form, 'button[type="submit"]'));
      btns.forEach(function (b) { b.setAttribute('aria-busy', 'true'); b.disabled = true; });
      var err = form.querySelector('[data-nv-error]'); if (err) err.hidden = true;
      var fd = new FormData(form);
      fd.append('sections', 'nv-cart-drawer');
      fd.append('sections_url', window.location.pathname);
      cartRequest(root() + 'cart/add.js', fd, true)
        .then(function (item) {
          renderDrawer(item.sections && item.sections['nv-cart-drawer']);
          return refreshCount().then(function () { drawerOpen(); });
        })
        .catch(function (ex) { if (err) { err.textContent = ex.message; err.hidden = false; } else { form.submit(); } })
        .then(function () { btns.forEach(function (b) { b.removeAttribute('aria-busy'); b.disabled = false; }); d.dispatchEvent(new CustomEvent('nv:cart-updated')); });
    });
  }

  /* ---------- galerie produit ---------- */
  function initGallery(rootEl) {
    var slides = qsa(rootEl, '[data-nv-slide]');
    var thumbs = qsa(rootEl, '[data-nv-thumb]');
    var counter = rootEl.querySelector('[data-nv-count]');
    if (slides.length < 2) return null;
    var cur = 0;
    slides.forEach(function (s, k) { if (!s.hidden) cur = k; });
    function show(i) {
      if (i < 0) i = slides.length - 1;
      if (i >= slides.length) i = 0;
      cur = i;
      slides.forEach(function (s, k) {
        var on = k === i;
        s.hidden = !on;
        if (!on) qsa(s, 'video').forEach(function (v) { try { v.pause(); } catch (e) {} });
      });
      thumbs.forEach(function (t, k) { t.setAttribute('aria-current', k === i ? 'true' : 'false'); });
      if (counter) counter.textContent = i + 1;
      var th = thumbs[i]; if (th && th.scrollIntoView && th.parentElement) { var ul = th.closest('ul'); if (ul) ul.scrollLeft = th.parentElement.offsetLeft - 20; }
    }
    thumbs.forEach(function (t, k) { t.addEventListener('click', function () { show(k); }); });
    var prev = rootEl.querySelector('[data-nv-prev]'), next = rootEl.querySelector('[data-nv-next]');
    if (prev) prev.addEventListener('click', function () { show(cur - 1); });
    if (next) next.addEventListener('click', function () { show(cur + 1); });
    var stage = rootEl.querySelector('[data-nv-stage]');
    if (stage) {
      var x0 = null, y0 = null;
      stage.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; }, { passive: true });
      stage.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0, dy = e.changedTouches[0].clientY - y0;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) show(cur + (dx < 0 ? 1 : -1));
        x0 = null;
      }, { passive: true });
    }
    return { show: show };
  }

  /* ---------- variantes ---------- */
  function initProduct(rootEl, gallery) {
    var dataEl = rootEl.querySelector('[data-nv-variants]');
    if (!dataEl) return;
    var variants = [];
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var cfg = {};
    try { cfg = JSON.parse(rootEl.getAttribute('data-nv-config') || '{}'); } catch (e) {}
    var groups = qsa(rootEl, '[data-nv-option]');
    var select = rootEl.querySelector('[data-nv-id]');
    var subGroup = rootEl.querySelector('[data-nv-subopt]');
    var spInput = rootEl.querySelector('[data-nv-sp-input]');
    var cmpNote = rootEl.querySelector('[data-nv-compare-note]');
    var cmpNoteText = cmpNote ? cmpNote.textContent : '';
    function plan() { var c = subGroup && subGroup.querySelector('input:checked'); return c && c.value ? c.value : ''; }
    function values() {
      var vals = [];
      groups.forEach(function (g, k) {
        var idx = g.hasAttribute('data-nv-index') ? parseInt(g.getAttribute('data-nv-index'), 10) : k;
        var c = g.querySelector('input:checked'); vals[idx] = c ? c.value : null;
      });
      return vals;
    }
    function match(vals) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i], ok = true;
        for (var j = 0; j < vals.length; j++) { if (v.options[j] !== vals[j]) { ok = false; break; } }
        if (ok) return v;
      }
      return null;
    }
    function setAll(sel, txt) { qsa(rootEl, sel).forEach(function (el) { el.textContent = txt; }); }
    function setLabel(b, txt) { var l = b.querySelector('[data-nv-label]'); (l || b).textContent = txt; }
    function update(pushUrl) {
      if (!groups.length && !subGroup) return;
      groups.forEach(function (g) { var c = g.querySelector('input:checked'), lab = g.querySelector('[data-nv-selected]'); if (c && lab) lab.textContent = c.value; });
      var v = match(values());
      var btns = qsa(rootEl, '[data-nv-submit]');
      if (!v) { btns.forEach(function (b) { b.disabled = true; setLabel(b, cfg.unavailable || 'Indisponible'); }); return; }
      try { d.dispatchEvent(new CustomEvent('nv:variant', { detail: { id: v.id, options: v.options } })); } catch (e) {}
      if (select) select.value = String(v.id);
      var pid = plan(), spv = pid && v.sp ? v.sp[pid] : null;
      if (spInput) { spInput.value = spv ? pid : ''; spInput.disabled = !spv; }
      var shown = spv ? spv.price : v.price;
      setAll('[data-nv-price]', shown);
      setAll('[data-nv-perday]', spv ? spv.per_day : v.per_day);
      qsa(rootEl, '[data-nv-price-suffix]').forEach(function (el) { el.hidden = !spv; });
      setAll('[data-nv-sachets]', v.sachets);
      setAll('[data-nv-recharges]', v.recharges);
      setAll('[data-nv-note]', v.note);
      setAll('[data-nv-duration]', v.duration);
      setAll('[data-nv-saving]', v.saving);
      qsa(rootEl, '[data-nv-saving-wrap]').forEach(function (el) { el.hidden = !v.saving; });
      if (typeof v.bonus === 'string') setAll('[data-nv-bonus]', v.bonus);
      var cmp = spv ? spv.compare : v.compare;
      setAll('[data-nv-compare]', cmp || '');
      qsa(rootEl, '[data-nv-compare-wrap],[data-nv-compare-note]').forEach(function (el) { el.hidden = !cmp; });
      if (cmpNote) cmpNote.textContent = spv && cfg.subNote ? cfg.subNote : cmpNoteText;
      if (gallery && typeof v.media === 'number') gallery.show(v.media >= 0 ? v.media : 0);
      btns.forEach(function (b) {
        b.disabled = !v.available;
        if (!v.available) { setLabel(b, cfg.soldOut || 'Épuisé'); return; }
        if (spv) setLabel(b, b.hasAttribute('data-nv-full') ? ((cfg.subscribe || cfg.add) + ' · ' + spv.price + (cfg.per || '')) : (cfg.subscribe || cfg.add));
        else setLabel(b, b.hasAttribute('data-nv-full') ? (cfg.add + ' · ' + v.price) : cfg.add);
      });
      if (pushUrl && window.history && history.replaceState) {
        try { var u = new URL(window.location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u.toString()); } catch (e) {}
      }
    }
    groups.forEach(function (g) { g.addEventListener('change', function () { update(true); }); });
    if (subGroup) {
      subGroup.addEventListener('change', function () { update(false); });
      var subRadio = subGroup.querySelector('input:not([value=""])');
      if (subRadio && window.location.hash === '#' + subGroup.id) subRadio.checked = true;
      // lien #abonnement suivi depuis la même page : on coche aussi l'abonnement
      window.addEventListener('hashchange', function () {
        if (subRadio && window.location.hash === '#' + subGroup.id && !subRadio.checked) { subRadio.checked = true; update(false); }
      });
    }
    update(false);
    rootEl.nvPick = function (value) {
      for (var i = 0; i < groups.length; i++) {
        var inputs = qsa(groups[i], 'input');
        for (var k = 0; k < inputs.length; k++) {
          if (inputs[k].value === value) { inputs[k].checked = true; update(true); return true; }
        }
      }
      return false;
    };
  }

  function initSticky(rootEl) {
    var bar = rootEl.querySelector('[data-nv-sticky]');
    var target = rootEl.querySelector('[data-nv-main-submit]');
    if (!bar || !target || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      var e = entries[0];
      var past = !e.isIntersecting && e.boundingClientRect.top < 0;
      bar.classList.toggle('is-visible', past);
      d.body.classList.toggle('nv-has-sticky', past);
    });
    io.observe(target);
  }

  /* ---------- choix des saveurs : le client compose ses sachets, envoyé avec la commande (propriété de ligne) ---------- */
  function slug(t) {
    t = String(t || '');
    try { t = t.normalize('NFD').replace(/[\u0300-\u036f]/g, ''); } catch (e) {}
    return t.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
  }
  function initPicker(rootEl) {
    var el = rootEl.querySelector('[data-nv-picker]');
    if (!el) return;
    var items = qsa(el, '[data-nv-pick-item]');
    var input = el.querySelector('[data-nv-pick-input]');
    var countEl = el.querySelector('[data-nv-pick-count]'), nEl = el.querySelector('[data-nv-pick-n]');
    var hint = el.querySelector('[data-nv-pick-hint]');
    var allBtn = el.querySelector('[data-nv-pick-all]');
    var baseHint = hint ? hint.textContent : '';
    var form = input && input.getAttribute('form') ? d.getElementById(input.getAttribute('form')) : null;
    var required = el.getAttribute('data-required') !== 'false';
    var n = parseInt(el.getAttribute('data-n'), 10) || 3;
    var picks = [];
    var variants = [];
    try { variants = JSON.parse((rootEl.querySelector('[data-nv-variants]') || {}).textContent || '[]'); } catch (e) {}
    var names = items.map(function (it) { return it.getAttribute('data-name'); });
    function sachets(k) { return k > 1 ? 'sachets' : 'sachet'; }
    function counts() { var c = {}; picks.forEach(function (p) { c[p] = (c[p] || 0) + 1; }); return c; }
    function render(msg, isErr) {
      var c = counts();
      items.forEach(function (it) {
        var name = it.getAttribute('data-name'), k = c[name] || 0;
        var badge = it.querySelector('[data-nv-pick-badge]'), minus = it.querySelector('[data-nv-pick-minus]'), add = it.querySelector('[data-nv-pick-add]');
        if (badge) { badge.textContent = '×' + k; badge.hidden = k === 0; }
        if (minus) minus.hidden = k === 0;
        it.classList.toggle('is-on', k > 0);
        if (add) add.setAttribute('aria-label', name + (k ? ' (' + k + ' ' + sachets(k) + ')' : '') + ' : ajouter un sachet');
      });
      if (countEl) countEl.textContent = picks.length;
      if (nEl) nEl.textContent = n;
      el.classList.toggle('is-full', picks.length >= n);
      if (allBtn) allBtn.hidden = n < names.length;
      el.classList.toggle('is-error', !!isErr);
      var left = n - picks.length;
      if (hint) hint.textContent = msg || (picks.length === 0 ? baseHint.replace(/\d+ sachets/, n + ' sachets')
        : left > 0 ? 'Encore ' + left + ' ' + sachets(left) + ' à choisir.' : 'Parfait : tes ' + n + ' sachets sont choisis.');
      var order = [];
      picks.forEach(function (p) { if (order.indexOf(p) < 0) order.push(p); });
      if (input) input.value = order.map(function (p) { return c[p] > 1 ? p + ' ×' + c[p] : p; }).join(', ');
    }
    function add(name) {
      if (names.indexOf(name) < 0) return false;
      if (picks.length >= n) { render('Tes ' + n + ' sachets sont choisis. Retire une saveur (−) pour en changer.'); return false; }
      picks.push(name); render(); return true;
    }
    function removeOne(name) { var i = picks.lastIndexOf(name); if (i > -1) picks.splice(i, 1); render(); }
    function fillRandom() {
      var pool = names.filter(function (x) { return picks.indexOf(x) < 0; });
      while (picks.length < n) {
        if (!pool.length) pool = names.slice();
        picks.push(pool.splice(Math.floor(Math.random() * pool.length), 1)[0]);
      }
      render();
    }
    function fillAll() {
      picks = names.slice(0, n);
      while (picks.length < n) picks.push(names[Math.floor(Math.random() * names.length)]);
      render();
    }
    function setN(k) { if (!k || k === n) return; n = k; while (picks.length > n) picks.pop(); render(); }
    function nFor(id) { for (var i = 0; i < variants.length; i++) { if (String(variants[i].id) === String(id) && variants[i].n) return variants[i].n; } return 0; }
    function valid() { return !required || picks.length === n; }
    function fail() {
      var left = n - picks.length;
      render('Choisis encore ' + left + ' ' + sachets(left) + ' avant d’ajouter au panier.', true);
      el.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' });
      var first = el.querySelector('[data-nv-pick-add]');
      if (first) { try { first.focus({ preventScroll: true }); } catch (e) { first.focus(); } }
    }
    el.addEventListener('click', function (e) {
      var plus = e.target.closest('[data-nv-pick-add]'), minus = e.target.closest('[data-nv-pick-minus]');
      if (plus) add(plus.closest('[data-nv-pick-item]').getAttribute('data-name'));
      else if (minus) removeOne(minus.closest('[data-nv-pick-item]').getAttribute('data-name'));
      else if (e.target.closest('[data-nv-pick-random]')) fillRandom();
      else if (e.target.closest('[data-nv-pick-all]')) fillAll();
    });
    if (form) {
      form.addEventListener('submit', function (e) { if (valid()) return; e.preventDefault(); e.stopPropagation(); fail(); });
      var express = form.querySelector('.nv-dynamic-checkout');
      if (express) express.addEventListener('click', function (e) { if (valid()) return; e.preventDefault(); e.stopPropagation(); fail(); }, true);
    }
    d.addEventListener('nv:variant', function (e) { setN(nFor(e.detail && e.detail.id)); });
    var sel = rootEl.querySelector('[data-nv-id]');
    if (sel) setN(nFor(sel.value));
    rootEl.nvAddFlavor = function (name) {
      for (var i = 0; i < names.length; i++) { if (names[i] === name || slug(names[i]) === slug(name)) return add(names[i]); }
      return false;
    };
    rootEl.nvPicker = el;
    render();
    var m = /^#saveur-([a-z0-9-]+)$/i.exec(window.location.hash || '');
    if (m) rootEl.nvAddFlavor(m[1]);
  }

  /* cartes saveurs : sur la page du produit, choisir la saveur sans recharger */
  function initFlavorPick() {
    d.addEventListener('click', function (e) {
      var f = e.target.closest('[data-nv-flavor]');
      if (f) {
        var host = d.querySelector('[data-nv-product]');
        if (!host || typeof host.nvAddFlavor !== 'function') return;
        var fpath = '';
        try { fpath = new URL(f.getAttribute('href') || '', window.location.href).pathname; } catch (err) {}
        if (fpath !== window.location.pathname) return;
        e.preventDefault();
        host.nvAddFlavor(f.getAttribute('data-nv-flavor'));
        if (host.nvPicker) host.nvPicker.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' });
        return;
      }
      var a = e.target.closest('[data-nv-pick]');
      if (!a) return;
      var prod = d.querySelector('[data-nv-product]');
      if (!prod || typeof prod.nvPick !== 'function') return;
      var href = a.getAttribute('href') || '';
      var path = href.split('?')[0].split('#')[0];
      try { path = new URL(href, window.location.href).pathname; } catch (err) {}
      if (path !== window.location.pathname) return;
      if (prod.nvPick(a.getAttribute('data-nv-pick'))) {
        e.preventDefault();
        prod.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
      }
    });
  }

  /* ---------- « Pourquoi » ---------- */
  function initWhy(el) {
    var items = qsa(el, '[data-nv-why-item]');
    if (!items.length) return;
    var imgs = qsa(el, '[data-nv-why-img]');
    var pauseBtn = el.querySelector('[data-nv-why-pause]');
    var interval = parseInt(el.getAttribute('data-interval'), 10) || 7000;
    var autoplay = el.getAttribute('data-autoplay') === 'true' && !reduceMotion;
    /* Sur téléphone, pas de défilement automatique : le texte qui change pendant la lecture fait bouger la page. */
    var small = window.matchMedia ? window.matchMedia('(max-width: 749px)') : null;
    var userPaused = false;
    var paused = !autoplay || !!(small && small.matches);
    var visible = false, cur = 0, timer = null;
    function bar(i) { return items[i].querySelector('.nv-why__bar span'); }
    function resetBars() { items.forEach(function (it, k) { var b = bar(k); if (b) { b.style.transition = 'none'; b.style.width = '0'; } }); }
    function open(i) {
      cur = i;
      items.forEach(function (it, k) {
        var on = k === i;
        it.classList.toggle('is-open', on);
        var btn = it.querySelector('.nv-why__btn'); if (btn) btn.setAttribute('aria-expanded', on ? 'true' : 'false');
        var p = it.querySelector('.nv-why__panel'); if (p) p.hidden = !on;
      });
      imgs.forEach(function (im, k) { im.classList.toggle('is-active', k === i); });
      resetBars(); run();
    }
    function run() {
      clearTimeout(timer);
      if (paused || !visible || items.length < 2) return;
      var b = bar(cur);
      if (b) { void b.offsetWidth; b.style.transition = 'width ' + interval + 'ms linear'; b.style.width = '100%'; }
      timer = setTimeout(function () { open((cur + 1) % items.length); }, interval);
    }
    function setPaused(p) {
      paused = p; clearTimeout(timer); resetBars();
      if (pauseBtn) {
        pauseBtn.setAttribute('aria-pressed', p ? 'true' : 'false');
        var lab = pauseBtn.querySelector('[data-nv-why-pause-label]'); if (lab) lab.textContent = p ? 'Lecture' : 'Pause';
      }
      run();
    }
    function syncScreen() {
      var isSmall = !!(small && small.matches);
      if (pauseBtn) pauseBtn.hidden = isSmall || !autoplay;
      setPaused(!autoplay || isSmall || userPaused);
    }
    items.forEach(function (it, k) {
      var btn = it.querySelector('.nv-why__btn');
      if (btn) btn.addEventListener('click', function () { if (!paused) { userPaused = true; setPaused(true); } open(k); });
    });
    if (pauseBtn) pauseBtn.addEventListener('click', function () { userPaused = !paused; setPaused(userPaused); });
    if (small) {
      if (small.addEventListener) small.addEventListener('change', syncScreen);
      else if (small.addListener) small.addListener(syncScreen);
    }
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (en) { visible = en[0].isIntersecting; if (visible) run(); else clearTimeout(timer); }, { threshold: 0.35 }).observe(el);
    } else { visible = true; }
    syncScreen();
    open(0);
  }

  /* ---------- FAQ à onglets ---------- */
  function initFaq(el) {
    var tabs = qsa(el, '[data-nv-faq-tab]');
    if (!tabs.length) return;
    var items = qsa(el, 'details[data-cat]');
    function sel(cat) {
      tabs.forEach(function (t) { t.setAttribute('aria-selected', t.getAttribute('data-nv-faq-tab') === cat ? 'true' : 'false'); });
      items.forEach(function (dt) { dt.hidden = dt.getAttribute('data-cat') !== cat; });
    }
    tabs.forEach(function (t) { t.addEventListener('click', function () { sel(t.getAttribute('data-nv-faq-tab')); }); });
    sel(tabs[0].getAttribute('data-nv-faq-tab'));
  }

  /* ---------- page panier ---------- */
  function initCartPage(el) {
    var form = el.querySelector('form[data-nv-cart-form]');
    if (!form) return;
    qsa(el, '[data-nv-qty]').forEach(function (wrap) {
      var input = wrap.querySelector('input');
      qsa(wrap, 'button[data-step]').forEach(function (b) {
        b.addEventListener('click', function () {
          var step = parseInt(b.getAttribute('data-step'), 10) || 0;
          input.value = Math.max(0, (parseInt(input.value, 10) || 0) + step);
          form.submit();
        });
      });
      input.addEventListener('change', function () { form.submit(); });
    });
  }

  /* ---------- stories façon Instagram ---------- */
  var SEEN_KEY = 'nv-stories-seen';
  function seenList() { try { var l = JSON.parse(window.localStorage.getItem(SEEN_KEY) || '[]'); return Array.isArray(l) ? l : []; } catch (e) { return []; } }
  function markSeen(key) {
    if (!key) return;
    try { var l = seenList(); if (l.indexOf(key) < 0) { l.push(key); window.localStorage.setItem(SEEN_KEY, JSON.stringify(l.slice(-60))); } } catch (e) {}
  }
  function initStories(sec) {
    if (sec.nvStories) return;
    var circles = qsa(sec, '[data-nv-story-open]');
    var tpls = qsa(sec, 'template[data-nv-story-tpl]');
    var dlg = sec.querySelector('[data-nv-sv]');
    if (!circles.length || !dlg || circles.length !== tpls.length) return;
    sec.nvStories = true;
    var wrap = dlg.querySelector('[data-nv-sv-wrap]'), card = dlg.querySelector('[data-nv-sv-card]'), stage = dlg.querySelector('[data-nv-sv-stage]');
    var bars = dlg.querySelector('[data-nv-sv-bars]'), avatar = dlg.querySelector('[data-nv-sv-avatar]'), title = dlg.querySelector('[data-nv-sv-title]');
    var btnPause = dlg.querySelector('[data-nv-sv-pause]'), btnMute = dlg.querySelector('[data-nv-sv-mute]'), btnClose = dlg.querySelector('[data-nv-sv-close]');
    var cta = dlg.querySelector('[data-nv-sv-cta]'), live = dlg.querySelector('[data-nv-sv-live]');
    var prevStoryBtn = dlg.querySelector('[data-nv-sv-prevstory]'), nextStoryBtn = dlg.querySelector('[data-nv-sv-nextstory]');
    var L = { pause: sec.getAttribute('data-l-pause') || 'Pause', play: sec.getAttribute('data-l-play') || 'Lecture',
              mute: sec.getAttribute('data-l-mute') || 'Couper le son', unmute: sec.getAttribute('data-l-unmute') || 'Activer le son' };
    var base = (parseFloat(sec.getAttribute('data-duration')) || 6) * 1000;
    var seen = seenList();
    circles.forEach(function (c) { if (seen.indexOf(c.getAttribute('data-key')) >= 0) c.classList.add('is-seen'); });

    var cur = -1, idx = 0, slides = [], barEls = [], elapsed = 0, last = 0, raf = 0;
    var userPaused = false, holding = false, muted = true, isOpen = false, opener = null;
    function isPaused() { return userPaused || holding || d.hidden; }
    function media() { var s = slides[idx]; return s ? s.querySelector('video') : null; }
    function setBars(k, p) {
      barEls.forEach(function (b, j) { b.firstChild.style.transform = 'scaleX(' + (j < k ? 1 : j > k ? 0 : Math.max(0, Math.min(1, p))) + ')'; });
    }
    function syncMedia() {
      var v = media(); if (!v) return;
      if (isPaused() || !isOpen) v.pause();
      else {
        var pr = v.play();
        // lecture automatique refusée par le navigateur : on passe en pause, le bouton Lecture relance
        if (pr && pr.catch) pr.catch(function (err) { if (err && err.name === 'NotAllowedError' && isOpen && media() === v) { userPaused = true; syncUi(); } });
      }
    }
    function syncUi() {
      dlg.classList.toggle('is-paused', userPaused);
      dlg.classList.toggle('is-holding', holding);
      dlg.classList.toggle('is-unmuted', !muted);
      btnPause.setAttribute('aria-label', userPaused ? L.play : L.pause);
      btnMute.setAttribute('aria-label', muted ? L.unmute : L.mute);
    }
    function loop(t) {
      raf = window.requestAnimationFrame(loop);
      var dt = last ? Math.min(t - last, 1000) : 0; last = t;
      if (isPaused() || !slides.length) return;
      var v = media(), p;
      if (v) p = v.duration && isFinite(v.duration) ? v.currentTime / v.duration : 0;
      else { elapsed += dt; p = elapsed / base; }
      setBars(idx, p);
      if (!v && p >= 1) next();
    }
    function show(k) {
      var old = media(); if (old) old.pause();
      idx = k; elapsed = 0;
      slides.forEach(function (s, j) { s.classList.toggle('is-on', j === k); s.setAttribute('aria-hidden', j === k ? 'false' : 'true'); });
      var nx = slides[k + 1];
      if (nx) { var ni = nx.querySelector('img'); if (ni) ni.loading = 'eager'; var nv = nx.querySelector('video'); if (nv) nv.preload = 'metadata'; }
      var v = media();
      btnMute.hidden = !v;
      if (v) {
        v.muted = muted; v.playsInline = true; v.preload = 'auto';
        try { v.currentTime = 0; } catch (e) {}
        v.onended = function () { if (media() === v && isOpen) next(); };
        syncMedia();
      }
      setBars(k, 0);
      var h = slides[k] && slides[k].querySelector('.nv-sv__h');
      live.textContent = (title.textContent ? title.textContent + ', ' : '') + (k + 1) + ' / ' + slides.length + (h ? ' : ' + h.textContent : '');
    }
    function load(i, k) {
      var tpl = tpls[i]; if (!tpl) return;
      var old = media(); if (old) old.pause();
      cur = i;
      stage.innerHTML = '';
      stage.appendChild(tpl.content.cloneNode(true));
      slides = qsa(stage, '[data-nv-sv-slide]');
      if (slides[0]) { var fi = slides[0].querySelector('img'); if (fi) fi.loading = 'eager'; }
      bars.innerHTML = '';
      barEls = slides.map(function () { var b = d.createElement('span'); b.className = 'nv-sv__bar'; b.appendChild(d.createElement('i')); bars.appendChild(b); return b; });
      title.textContent = tpl.getAttribute('data-label') || '';
      var av = tpl.getAttribute('data-cover');
      if (av) { avatar.src = av; avatar.hidden = false; } else avatar.hidden = true;
      var cl = tpl.getAttribute('data-cta-label'), cu = tpl.getAttribute('data-cta-link');
      if (cl && cu) { cta.textContent = cl; cta.setAttribute('href', cu); cta.hidden = false; } else cta.hidden = true;
      dlg.classList.toggle('has-cta', !cta.hidden);
      dlg.setAttribute('aria-label', (sec.getAttribute('data-label') || 'Stories') + (title.textContent ? ' : ' + title.textContent : ''));
      prevStoryBtn.disabled = i === 0; nextStoryBtn.disabled = i === tpls.length - 1;
      var c = circles[i]; if (c) { c.classList.add('is-seen'); markSeen(c.getAttribute('data-key')); }
      if (!slides.length) { setBars(0, 0); return; }
      show(Math.max(0, Math.min(k || 0, slides.length - 1)));
    }
    function animate(dir) {
      if (reduceMotion) return;
      card.classList.remove('is-in-next', 'is-in-prev'); void card.offsetWidth;
      card.classList.add(dir > 0 ? 'is-in-next' : 'is-in-prev');
    }
    function story(dir) {
      var j = cur + dir;
      if (j < 0) { show(0); return; }
      if (j >= tpls.length) { close(); return; }
      load(j, 0); animate(dir);
    }
    function next() { if (idx < slides.length - 1) show(idx + 1); else story(1); }
    function prev() { if (idx > 0) show(idx - 1); else story(-1); }
    function open(i, opts) {
      if (!isOpen) {
        opener = d.activeElement;
        if (typeof dlg.showModal === 'function') { try { dlg.showModal(); } catch (e) { dlg.setAttribute('open', ''); } }
        else dlg.setAttribute('open', '');
        d.documentElement.classList.add('nv-sv-open');
        isOpen = true; last = 0;
        window.cancelAnimationFrame(raf); raf = window.requestAnimationFrame(loop);
      }
      userPaused = !!(opts && opts.paused); holding = false; syncUi();
      load(i, 0);
      try { btnClose.focus({ preventScroll: true }); } catch (e) { btnClose.focus(); }
    }
    function close() {
      if (!isOpen) return;
      isOpen = false; holding = false;
      window.cancelAnimationFrame(raf);
      var v = media(); if (v) v.pause();
      stage.innerHTML = ''; slides = []; barEls = [];
      card.classList.remove('is-in-next', 'is-in-prev', 'is-dragging'); card.style.transform = '';
      if (dlg.open && typeof dlg.close === 'function') dlg.close(); else dlg.removeAttribute('open');
      d.documentElement.classList.remove('nv-sv-open');
      if (opener && opener.focus && d.contains(opener)) { try { opener.focus({ preventScroll: true }); } catch (e) { opener.focus(); } }
    }
    function togglePause() { userPaused = !userPaused; last = 0; syncUi(); syncMedia(); }

    circles.forEach(function (c, i) { c.addEventListener('click', function () { open(i); }); });
    btnClose.addEventListener('click', close);
    btnPause.addEventListener('click', togglePause);
    btnMute.addEventListener('click', function () { muted = !muted; var v = media(); if (v) v.muted = muted; syncUi(); syncMedia(); });
    prevStoryBtn.addEventListener('click', function () { story(-1); });
    nextStoryBtn.addEventListener('click', function () { story(1); });
    cta.addEventListener('click', function () { close(); });
    dlg.addEventListener('cancel', function (e) { e.preventDefault(); close(); });
    dlg.addEventListener('close', function () { if (isOpen) close(); });
    wrap.addEventListener('click', function (e) { if (e.target === wrap) close(); });
    dlg.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); next(); }
      else if (e.key === 'ArrowLeft') { e.preventDefault(); prev(); }
      else if (e.key === 'Escape' && typeof dlg.showModal !== 'function') { close(); }
      else if ((e.key === ' ' || e.key === 'Spacebar') && !(e.target.closest && e.target.closest('button, a'))) { e.preventDefault(); togglePause(); }
    });
    d.addEventListener('visibilitychange', function () { if (isOpen) { last = 0; syncMedia(); } });

    // gestes : toucher court = écran suivant/précédent (clic des zones), appui long = pause, glisser = story voisine ou fermer
    var pid = null, px = 0, py = 0, moved = false, suppress = false, holdTimer = 0;
    function startHold() { holding = true; suppress = true; last = 0; syncUi(); syncMedia(); }
    card.addEventListener('pointerdown', function (e) {
      if (e.button > 0 || (e.target.closest && e.target.closest('.nv-sv__top, .nv-sv__cta'))) return;
      pid = e.pointerId; px = e.clientX; py = e.clientY; moved = false; suppress = false;
      window.clearTimeout(holdTimer); holdTimer = window.setTimeout(startHold, 230);
    });
    card.addEventListener('pointermove', function (e) {
      if (pid !== e.pointerId) return;
      var dx = e.clientX - px, dy = e.clientY - py;
      if (!moved && Math.abs(dx) + Math.abs(dy) > 12) { moved = true; window.clearTimeout(holdTimer); if (!holding) startHold(); }
      if (moved && dy > 0 && dy > Math.abs(dx)) { card.classList.add('is-dragging'); card.style.transform = 'translateY(' + dy + 'px) scale(' + Math.max(0.88, 1 - dy / 1500) + ')'; }
    });
    function endPointer(e) {
      if (pid !== e.pointerId) return;
      pid = null; window.clearTimeout(holdTimer);
      var dx = e.clientX - px, dy = e.clientY - py;
      card.classList.remove('is-dragging'); card.style.transform = '';
      if (suppress) window.setTimeout(function () { suppress = false; }, 400);
      if (moved && dy > 90 && dy > Math.abs(dx)) { close(); return; }
      if (holding) { holding = false; last = 0; syncUi(); }
      if (moved && Math.abs(dx) > 60 && Math.abs(dx) > Math.abs(dy)) { story(dx < 0 ? 1 : -1); }
      syncMedia();
    }
    card.addEventListener('pointerup', endPointer);
    card.addEventListener('pointercancel', endPointer);
    qsa(dlg, '[data-nv-sv-tap]').forEach(function (b) {
      b.addEventListener('click', function () {
        if (suppress) { suppress = false; return; }
        if (b.getAttribute('data-nv-sv-tap') === 'next') next(); else prev();
      });
    });
    // éditeur de thème : sélectionner une story l'ouvre (en pause)
    d.addEventListener('shopify:block:select', function (e) { var i = circles.indexOf(e.target); if (i >= 0) open(i, { paused: true }); });
    d.addEventListener('shopify:block:deselect', function (e) { if (circles.indexOf(e.target) >= 0) close(); });
    d.addEventListener('shopify:section:unload', function (e) { if (e.target.contains(sec)) close(); });
  }

  /* ---- pop-up « guide offert » : une fois par visiteur, jamais par-dessus une autre fenêtre ---- */
  function initPopup(dlg) {
    if (dlg.nvInit || typeof dlg.showModal !== 'function') return;
    dlg.nvInit = true;
    var KEY = 'nv-guide-pop';
    var days = parseFloat(dlg.getAttribute('data-days')) || 30;
    var delay = (parseFloat(dlg.getAttribute('data-delay')) || 20) * 1000;
    var design = dlg.getAttribute('data-design') === 'true';
    var form = dlg.querySelector('form');
    var email = dlg.querySelector('input[type="email"]');
    var err = dlg.querySelector('.nv-pop__err');
    var ask = dlg.querySelector('[data-nv-pop-ask]');
    var done = dlg.querySelector('[data-nv-pop-done]');
    var last = null, shown = false, t0 = Date.now(), timer = null;
    function seenAt() { try { return parseInt(localStorage.getItem(KEY), 10) || 0; } catch (e) { return 0; } }
    function markSeen() { try { localStorage.setItem(KEY, String(Date.now())); } catch (e) { /* stockage indisponible */ } }
    function busy() {
      return !!(d.querySelector('dialog[open]') || d.body.classList.contains('nv-drawer-open') ||
        (d.activeElement && /^(INPUT|TEXTAREA|SELECT)$/.test(d.activeElement.tagName)));
    }
    function cleanup() {
      clearTimeout(timer);
      window.removeEventListener('scroll', onScroll);
      d.removeEventListener('mouseout', onLeave);
    }
    function open(force) {
      if (dlg.open || (!force && (shown || busy()))) return;
      shown = true; cleanup(); markSeen();
      last = d.activeElement;
      dlg.showModal();
      var target = done && !done.hidden ? dlg.querySelector('#nv-pop-title-done') : null;
      if (target) { dlg.setAttribute('aria-labelledby', 'nv-pop-title-done'); target.focus(); }
    }
    function close() { if (dlg.open) dlg.close(); }
    function onScroll() {
      var h = d.documentElement.scrollHeight - window.innerHeight;
      if (h > 0 && window.scrollY / h > 0.55 && Date.now() - t0 > 8000) open();
    }
    function onLeave(e) { if (!e.relatedTarget && e.clientY <= 0 && Date.now() - t0 > 5000) open(); }
    function showDone() {
      if (ask) ask.hidden = true;
      if (done) done.hidden = false;
      dlg.setAttribute('aria-labelledby', 'nv-pop-title-done');
      var h = dlg.querySelector('#nv-pop-title-done'); if (h) h.focus();
    }
    dlg.nvDone = showDone;
    qsa(dlg, '[data-nv-pop-close]').forEach(function (b) { b.addEventListener('click', close); });
    dlg.addEventListener('click', function (e) { if (e.target === dlg) close(); });
    dlg.addEventListener('close', function () { if (last && last.focus) { try { last.focus({ preventScroll: true }); } catch (e) { last.focus(); } } });
    if (form && email) {
      form.addEventListener('submit', function (e) {
        var ok = email.value.trim() !== '' && email.checkValidity();
        if (err) err.hidden = ok;
        email.setAttribute('aria-invalid', ok ? 'false' : 'true');
        if (!ok) { e.preventDefault(); e.stopImmediatePropagation(); email.focus(); }
      }, true);
      email.addEventListener('input', function () { if (err && !err.hidden && email.checkValidity()) { err.hidden = true; email.setAttribute('aria-invalid', 'false'); } });
    }
    if (design) {
      var sec = dlg.closest('.shopify-section');
      d.addEventListener('shopify:section:select', function (e) { if (sec && e.target === sec) open(true); });
      d.addEventListener('shopify:section:deselect', function (e) { if (sec && e.target === sec) close(); });
      return;
    }
    /* retour après l'envoi du formulaire (la page se recharge sur #nv-pop-form) */
    if (location.hash === '#nv-pop-form' && (/[?&]customer_posted=true/.test(location.search) || (err && !err.hidden))) {
      setTimeout(function () { open(true); }, 300);
      return;
    }
    if (/[?&]customer_posted=true/.test(location.search)) { markSeen(); return; }
    var seen = seenAt();
    if (seen && Date.now() - seen < days * 864e5) return;
    timer = setTimeout(function retry() { if (busy()) { timer = setTimeout(retry, 4000); return; } open(); }, delay);
    window.addEventListener('scroll', onScroll, { passive: true });
    if (window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches) d.addEventListener('mouseout', onLeave);
  }

  function initScope(scope) {
    qsa(scope, '[data-nv-pop]').forEach(initPopup);
    qsa(scope, '[data-nv-stories]').forEach(initStories);
    qsa(scope, '[data-nv-ann]').forEach(initAnn);
    qsa(scope, '[data-nv-product]').forEach(function (r) { var g = initGallery(r); initProduct(r, g); initSticky(r); initPicker(r); });
    qsa(scope, '[data-nv-why]').forEach(initWhy);
    qsa(scope, '[data-nv-faq]').forEach(initFaq);
    qsa(scope, '[data-nv-cart]').forEach(initCartPage);
  }
  function boot() {
    initHeader();
    initDrawer();
    initAddForms();
    initFlavorPick();
    initScope(d);
  }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', boot); else boot();
  d.addEventListener('shopify:section:load', function (e) { initScope(e.target); if (e.target.querySelector('[data-nv-drawer]')) initDrawer(); });
})();
